import { styled } from '@mui/material/styles';

export const CarouselNavigationContainer = styled('div', {
    name: 'Carousel',
    slot: 'navigationContainer',
    skipSx: false,
})({
    display: 'flex',
    gap: 8,
});
